import React from "react";
import Drawer from "@mui/material/Drawer";
import { IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useTheme} from "../../../contexts/theme";

interface StyledDrawerProps {
    open: boolean;
    onClose: () => void;
    width?: string;
    children?: React.ReactNode;
}

const drawerWidth = 300; // Larghezza del drawer

const StyledDrawerComponent: React.FC<StyledDrawerProps> = ({ open, onClose, width = "300px", children}) => {

    const theme = useTheme();

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            variant="persistent"
            PaperProps={{
                sx: {
                    width: width,
                    backgroundColor: theme.palette.blue,
                    color: "white",
                    padding: 2,
                },
            }}
        >
            {/* Bottone per chiudere il drawer */}
            <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                <IconButton onClick={onClose} sx={{ color: "white" }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Contenuto del drawer */}
            <Box sx={{ marginTop: 5 }}>{children}</Box>
        </Drawer>
    );
};

export default StyledDrawerComponent;
